import axiosInstance from "../util/axiosInstance";

export const submitSupportMessage = async (formData) => {
  const response = await axiosInstance.post("/support", formData);
  return response.data;
};
